import React from "react";
import { useNode } from "@craftjs/core";
import {
  ColorInput,
  SelectInput,
  UnitInput,
  ToggleInput,
  Panel,
  Tabs,
  TextInput,
  Spacer,
  AlignInput,
  RangeNumberInput,
  RichTextFormatting,
} from "../../input";
import { supportLibrary } from "../../block-supports";

export const CustomHtmlSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));

  const {
    align,
    countStart = 0,
    countEnd = 100,
    countTime = 3,
    numPrefix = "",
    numSuffix = "",
    numFormat,
    numTSeparator,
    textColor,
    typoSize = "50px",
    typoLineHeight,
    typoLetterSpacing,
    typoWordSpacing,
    typoWeight,
    typoTransform,
    typoDecoration,
    typoStyle,
  } = props;

  function GeneralSettings() {
    return <></>;
  }

  function StyleSettings() {
    return (
      <>
        <></>
      </>
    );
  }

  function AdvancedSettings() {
    return (
      <>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </>
    );
  }
  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
    },
    {
      label: "Style",
      key: "style",
      children: StyleSettings(),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
    },
  ];

  return (
    <div>
      <AdvancedSettings />
    </div>
  );
};
